export default {"src":"/_next/static/media/minus_white.e7f26ddc.svg","height":2,"width":18,"blurWidth":0,"blurHeight":0};